module.exports = __webpack_public_path__ + "static/media/frog(17).62c9cda8.PNG";